import {
  Badge,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../../../utils/Colors";
import { IconButton } from "../../../components/buttons/IconButton";
import {
  MdOutlineDeleteOutline,
  MdOutlineModeEditOutline,
} from "react-icons/md";
import { User, UserRole } from "../../../../entity/User";
interface Props {
  users: User[];
  onEdit: (user: User) => void;
  onDelete: (userId: string) => void;
}
export const UsersTable: React.FC<Props> = ({ users, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const getRoleBadgeColor = (role: UserRole) => {
    switch (role) {
      case UserRole.ADMIN:
        return "blue";
      case UserRole.SUBADMIN:
        return "green";
      case UserRole.STORE_ADMIN:
        return "purple";
      case UserRole.STORE_EDITOR:
        return "orange";
      case UserRole.USER:
      default:
        return "gray";
    }
  };
  const getRoleDisplayName = (role: UserRole) => {
    switch (role) {
      case UserRole.ADMIN:
        return "Admin";
      case UserRole.SUBADMIN:
        return "Sub Admin";
      case UserRole.STORE_ADMIN:
        return "Store Admin";
      case UserRole.STORE_EDITOR:
        return "Store Editor";
      case UserRole.USER:
      default:
        return "User";
    }
  };
  return (
    <TableContainer mt={6}>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>{t("login.email")}</Th>
            <Th>{t("login.role")}</Th>
            <Th>{t("actions")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map((user) => (
            <Tr
              color={COLORS.Text.Primary}
              key={user.id}
              _hover={{ bg: "gray.50" }}
            >
              <Td color={COLORS.Text.Primary} fontWeight="medium">
                {user.email}
              </Td>
              <Td>
                <Badge
                  colorScheme={getRoleBadgeColor(user.role)}
                  textTransform="capitalize"
                >
                  {getRoleDisplayName(user.role)}
                </Badge>
              </Td>
              <Td>
                <HStack spacing={2}>
                  <IconButton label={t("edit")} onClick={() => onEdit(user)}>
                    <MdOutlineModeEditOutline size={20} />
                  </IconButton>
                  <IconButton
                    aria-label={t("delete")}
                    onClick={() => user.id && onDelete(user.id)}
                  >
                    <MdOutlineDeleteOutline
                      size={20}
                      color={COLORS.Palette.Red}
                    />
                  </IconButton>
                </HStack>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
